/* eslint-disable no-empty-pattern */
/*
 * @作者: jiguijian(jiguijian@hztianque.com)
 * @描述: drugVisit 请求模块
 * @创建日期: 2020-05-13 09:13:11
 */

import * as apis from './api'

// 初始化store对象
const state = {
  card: '12',
}

// 异步操作放到action handler里
const actions = {
  // 搜索&&类表
  async getQueryData({}, payload) {
    const res = await apis.getQueryData(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // async exportAllFiledResult({ commit }, payload) {// eslint-disable-line
  //   return new Promise(async (resolve, reject) => {// eslint-disable-line
  //     try {
  //       const rst = await http.download(apis.exportDataDeal, { ...payload }, {
  //         headers: {
  //           Accept: '*/*',
  //         },
  //         imdelate: true,
  //       })
  //       const blob = rst.data
  //       const a = document.createElement('a')
  //       const url = window.URL.createObjectURL(blob) // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
  //       const filename = 'Excel.xlsx'
  //       a.href = url
  //       a.download = filename
  //       a.click()
  //       window.URL.revokeObjectURL(url)
  //     } catch (error) {
  //       reject(error)
  //     }
  //   })
  // },
  // 导出&&类表
  async exportDataDeal({}, payload) {
    const res = await apis.exportDataDeal(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 删除
  async deleteByIds({}, payload) {
    const res = await apis.deleteByIds(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 酒店详情
  async hotelDetails({}, payload) {
    const res = await apis.hotelDetails(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  async updateSignUpHotel({}, payload) {
    const res = await apis.updateSignUpHotel(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
}
// 根据commit更新store
const mutations = {
  SET_USERINFO(state, info) {
    console.log('ttttt', info)
    state.card = info
  },
}
const getters = {
  getCard(state) {
    return state.card
  },
}
// 导出vuex模块
export default {
  // 模块开启命名空间
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}